import type { CanDeactivateFn } from '@angular/router';
import type { QboAccountComponent } from './qbo-account.component';

/** Leaving QBO Account with unsaved mapping changes asks first (sidebar, breadcrumb, Cost Code Library link, back button). */
export const qboAccountCanDeactivate: CanDeactivateFn<QboAccountComponent> = component => component.canLeave();
